<template>
  <svg
    width="208"
    height="172"
    viewBox="0 0 104 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M85.9936 0H17.2007C7.70103 0 0 7.70103 0 17.2007V68.7928C0 78.2925 7.70103 85.9936 17.2007 85.9936H85.9936C95.4933 85.9936 103.194 78.2925 103.194 68.7928V17.2007C103.194 7.70103 95.4933 0 85.9936 0Z"
      fill="#0B132B"
    />
    <g style="mix-blend-mode:hard-light">
      <path
        d="M103.194 17.1906L93.2424 19.671C66.4744 26.1706 39.3217 32.6804 13.0094 38.9877C8.66617 40.0304 4.32296 41.0732 0 42.1059V17.1906C0 7.68414 7.70439 0 17.2109 0H86.0037C95.5101 0 103.194 7.69427 103.194 17.1906Z"
        fill="url(#paint0_linear_9_1065)"
      />
    </g>
    <path
      d="M33.5712 58.3447C39.2687 58.3447 43.8875 53.7259 43.8875 48.0283C43.8875 42.3307 39.2687 37.7119 33.5712 37.7119C27.8736 37.7119 23.2548 42.3307 23.2548 48.0283C23.2548 53.7259 27.8736 58.3447 33.5712 58.3447Z"
      fill="#4CE0B3"
    />
    <path
      d="M33.5712 53.1926C36.4228 53.1926 38.7345 50.8809 38.7345 48.0293C38.7345 45.1778 36.4228 42.8661 33.5712 42.8661C30.7196 42.8661 28.408 45.1778 28.408 48.0293C28.408 50.8809 30.7196 53.1926 33.5712 53.1926Z"
      fill="#A6F4D8"
    />
    <path
      d="M69.633 58.4467C75.3306 58.4467 79.9494 53.8279 79.9494 48.1304C79.9494 42.4328 75.3306 37.814 69.633 37.814C63.9354 37.814 59.3166 42.4328 59.3166 48.1304C59.3166 53.8279 63.9354 58.4467 69.633 58.4467Z"
      fill="#4CE0B3"
    />
    <path
      d="M69.6331 53.2937C72.4846 53.2937 74.7963 50.982 74.7963 48.1304C74.7963 45.2788 72.4846 42.9672 69.6331 42.9672C66.7815 42.9672 64.4698 45.2788 64.4698 48.1304C64.4698 50.982 66.7815 53.2937 69.6331 53.2937Z"
      fill="#A6F4D8"
    />
    <path
      d="M33.8121 24.0102C34.4296 24.0102 35.0573 24.243 35.523 24.7188C36.4747 25.6705 36.4747 27.1992 35.523 28.1509C31.767 31.9069 26.786 34.0329 21.481 34.1443C20.1649 34.2051 19.031 33.1117 19.0006 31.7652C18.9702 30.4288 20.0332 29.3151 21.3797 29.2848C25.4293 29.1937 29.236 27.5738 32.091 24.7087C32.5668 24.2329 33.1844 24 33.8121 24L33.8121 24.0102Z"
      fill="#4CE0B3"
    />
    <path
      d="M82.8121 29.1366C83.4297 29.1366 84.0574 28.9037 84.5231 28.4279C85.4747 27.4762 85.4747 25.9475 84.5231 24.9958C80.767 21.2398 75.786 19.1138 70.481 19.0024C69.1649 18.9417 68.031 20.0351 68.0006 21.3816C67.9703 22.7179 69.0333 23.8316 70.3798 23.8619C74.4294 23.9531 78.236 25.5729 81.091 28.438C81.5668 28.9138 82.1844 29.1467 82.8121 29.1467V29.1366Z"
      fill="#4CE0B3"
    />
    <g style="mix-blend-mode:screen">
      <path
        style="mix-blend-mode:screen"
        opacity="0.68"
        d="M16.8156 47.7858C16.9371 34.8574 24.5403 24.4094 33.7936 24.4398C43.047 24.4803 50.4477 34.989 50.3262 47.9275C50.2047 60.8559 42.6015 71.3039 33.3482 71.2736C24.0948 71.2331 16.6941 60.7243 16.8156 47.7858Z"
        fill="url(#paint1_radial_9_1065)"
      />
    </g>
    <g style="mix-blend-mode:screen">
      <path
        style="mix-blend-mode:screen"
        opacity="0.68"
        d="M53.2625 47.7855C53.384 34.8572 60.9872 24.4091 70.2405 24.4395C79.4939 24.48 86.8946 34.9888 86.7731 47.9273C86.6516 60.8557 79.0484 71.3037 69.7951 71.2733C60.5417 71.2328 53.141 60.7241 53.2625 47.7855Z"
        fill="url(#paint2_radial_9_1065)"
      />
    </g>
    <path
      d="M85.9936 2.42977C94.1434 2.42977 100.765 9.06101 100.765 17.2007V68.8029C100.765 76.9528 94.1333 83.5739 85.9936 83.5739H17.2007C9.05088 83.5739 2.42976 76.9427 2.42976 68.8029V17.2007C2.42976 9.05089 9.06101 2.42977 17.2007 2.42977H85.9936ZM85.9936 0H17.2007C7.70439 0 0 7.70439 0 17.2007V68.8029C0 78.2993 7.70439 86.0037 17.2007 86.0037H85.9936C95.4899 86.0037 103.194 78.2993 103.194 68.8029V17.2007C103.194 7.70439 95.5 0 85.9936 0Z"
      fill="#0B132B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_9_1065"
        x1="125.012"
        y1="-14.9633"
        x2="18.5675"
        y2="22.8601"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2853E1" />
        <stop
          offset="1"
          stop-color="#2853E1"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint1_radial_9_1065"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.6114 47.5836) rotate(-180) scale(16.1985 15.7588)"
      >
        <stop stop-color="#4CE0B3" />
        <stop
          offset="1"
          stop-color="#4CE0B3"
          stop-opacity="0"
        />
      </radialGradient>
      <radialGradient
        id="paint2_radial_9_1065"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(70.0583 47.5834) rotate(-180) scale(16.1985 15.7588)"
      >
        <stop stop-color="#4CE0B3" />
        <stop
          offset="1"
          stop-color="#4CE0B3"
          stop-opacity="0"
        />
      </radialGradient>
    </defs>
  </svg>
</template>
